export default function parseInsured(insured) {
  const cleaned = { ...insured };

  if (!cleaned.emailCc) {
    cleaned.emailCc = '';
  }

  return cleaned;
}
